import StatusUno from '../../modules/ctr-r/troubleshooting/Components_Status/Status_one';
import StatusDos from '../../modules/ctr-r/troubleshooting/Components_Status/Status_two';
import BGPCTXR from '../../modules/ctr-r/troubleshooting/Components/BGPCTXR';
import { useAuth } from '../../modules/auth';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../../redux/hooks';
import LogsTable from '../../modules/ctr-r/troubleshooting/Components_logs/LogsTable';
import { Routes, Route, NavLink, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap'; // Importar Spinner para la carga

const TroubleshootingCTXR: React.FC = () => {
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions);
  const { currentUser } = useAuth();
  const [flag, setflag] = useState<number>();
  const [num, setnum] = useState<number>();
  const [loading, setLoading] = useState(true); // Estado para gestionar la carga
  const location = useLocation();
  const navigate = useNavigate();

  // Validación de permisos y redirección con estado de carga
  useEffect(() => {
    const delay = setTimeout(() => {
      if (ListaPermisosTenant.length > 0) {
        setLoading(false); // Detener la carga cuando los permisos estén cargados
        if (!ListaPermisosTenant.includes('CTXR.Troubleshooting.Status')) {
          // Si no tiene permisos para CTXR.Troubleshooting.Status, validamos si tiene Home.Status
          if (ListaPermisosTenant.includes('Home.Status')) {
            navigate('/dashboard/status');
          } else {
            // Si no tiene Home.Status, redirigimos a cloudConnectivity
            navigate('/cloudConnectivity');
          }
        }
      }
    }, 1000); // Retraso de 1 segundo

    // Limpiar timeout si el componente se desmonta
    return () => clearTimeout(delay);
  }, [ListaPermisosTenant, navigate]);

  // Establecer flags basados en los permisos del usuario
  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP')) {
      setflag(2);
      setnum(2);
    } else if (currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.BGP')) {
      setflag(3);
    } else if (currentUser?.ListPermiso?.includes('Ctx.Troubleshooting.MPLS')) {
      setflag(4);
    } else if (!ListaPermisosTenant.includes('CTXR.Troubleshooting.Status')) {
      setflag(1);
    }
  }, [currentUser, ListaPermisosTenant]);

  // Mostrar spinner mientras se cargan los permisos
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>We are validating your permissions...</div>
      </div>
    );
  }

  return (
    <div className='card mb-5 mb-xl-5'>
      <ul style={{ marginLeft: '25px', marginRight: '25px' }} className="nav nav-tabs nav-line-tabs mb-5 fs-6">
        {(currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP') || !ListaPermisosTenant.includes('CTXR.Troubleshooting.BGP')) && (
          <li className="nav-item f-parrafo fs-p">
            <NavLink
              className={`nav-link ${location.pathname.includes('bgp') ? 'active' : ''}`}
              to="bgp"
              onClick={() => (setflag(2), setnum(2))}
            >
              BGP
            </NavLink>
          </li>
        )}
        {(currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP') || !ListaPermisosTenant.includes('CTXR.Troubleshooting.BGP')) && (
          <li className="nav-item f-parrafo fs-p">
            <NavLink
              className={`nav-link ${location.pathname.includes('logs') ? 'active' : ''}`}
              to="logs"
              onClick={() => (setflag(3), setnum(3))}
            >
              Logs
            </NavLink>
          </li>
        )}
      </ul>
      <div style={{ marginLeft: '25px', marginRight: '25px' }} className="tab-content" id="myTabContent">
        <Routes>
          {(currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP') || !ListaPermisosTenant.includes('CTXR.Troubleshooting.BGP')) && (
            <Route path="bgp" element={
              <div className={`tab-pane fade ${flag === 2 ? 'active show' : ''}`} id="kt_tab_pane_2" role="tabpanel">
                <BGPCTXR tab={flag} num={num}></BGPCTXR>
              </div>
            } />
          )}
          {(currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP') || !ListaPermisosTenant.includes('CTXR.Troubleshooting.BGP')) && (
            <Route path="logs" element={
              <div className="tab-pane fade active show" id="kt_tab_pane_3" role="tabpanel">
                <LogsTable tab={flag} num={num} />
              </div>
            } />
          )}
          {/* Default route */}
          {(currentUser?.ListPermiso?.includes('CTXR.Troubleshooting.BGP') || !ListaPermisosTenant.includes('CTXR.Troubleshooting.BGP')) ? (
            <Route path="*" element={<Navigate to="bgp" />} />
          ) : (
            <Route path="*" element={<Navigate to="/accounts/billing" />} />
          )}
        </Routes>
      </div>
    </div>
  );
}

export { TroubleshootingCTXR };
